import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Link } from 'react-router-dom';

import { API_SUCCESS } from 'redux/api/constants';
import { Col, Row } from 'elements';
import { mfaSettings } from 'redux/modules/user';
import { MfaSettingsForm, PageContainer } from 'smart-components';
import { PageContent } from 'components';
import { mfaSettingsSelector } from 'redux/selectors';
import { userIsAuthenticatedRedir } from 'hocs/auth';
import './index.scss';

const COMPONENT_CSS_CLASS = 'mfa-settings';
const bemE = suffix => `${COMPONENT_CSS_CLASS}__${suffix}`;

class MfaSettings extends Component {
	static propTypes = {
		mfaSettings: PropTypes.func,
		mfaSettingsStatus: PropTypes.string,
	};

	componentWillReceiveProps(nextProps) {
		const { history } = this.props;
		if (
			this.props.mfaSettingsStatus !==
				nextProps.mfaSettingsStatus &&
			nextProps.mfaSettingsStatus === API_SUCCESS
		) {
			history.push('/');
		}
	}

	render() {
		return (
			<PageContainer>
				<PageContent>
					<PageContent.Main>
						<p className={bemE('back')}>
							<Link to="/">&laquo; Back</Link>
						</p>
						<Row>
							<Col xs={24} sm={14} md={12} xl={10}>
								<h1 className={bemE('title')}>
									2FA Settings
								</h1>
								<MfaSettingsForm />
							</Col>
						</Row>
					</PageContent.Main>
				</PageContent>
			</PageContainer>
		);
	}
}

export const selector = createStructuredSelector({
	mfaSettingsStatus: mfaSettingsSelector,
});

export const actions = {
	mfaSettings,
};

export default compose(
	userIsAuthenticatedRedir,
	connect(selector, actions),
)(MfaSettings);



// WEBPACK FOOTER //
// ./src/pages/mfa-settings/index.js